import PropTypes from 'prop-types';
import moment from 'moment';
import StepPoint from '../step-point';
import './international-header.css';

const InternationalHeader = ({ data, formatDate }) => {
  return (
    <div className="header-event-timeline">
      <StepPoint stopNow={data.Atual} />
      <div className="container-status-timeline">
        {/* Data/hora/usuário */}
        <div className="datetime-event">
          <span>{formatDate(data.DataStatus).format("L")}</span>
          <span> - {moment(data.HoraStatus, "HH:mm").format("LT")}</span>
          <span>: {data.NomeUsuario}</span>
        </div>
        
        {/* Portal Code */}
        <div className="status-timeline-id">
          Portal Code: <strong>{data.IdPedido}</strong>
        </div>
        
        {/* Status com ícone de erro */}
        <div className="status-timeline-error">
          <span className="error-icon">⊗</span>
          <span>{data.Status}</span>
        </div>
        
        {/* Mensagem de erro detalhada */}
        {data.Observacao && (
          <div className="error-detail-message">
            {data.Observacao}
          </div>
        )}
      </div>
    </div>
  );
};

InternationalHeader.propTypes = {
  data: PropTypes.object.isRequired,
  formatDate: PropTypes.func.isRequired,
};

export default InternationalHeader;
